import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-klasse-sechs-page',
  templateUrl: './klasse-sechs-page.component.html',
  styleUrls: ['./klasse-sechs-page.component.css']
})
export class KlasseSechsPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
